<router-outlet></router-outlet>
<p-confirmDialog header="Confirmación" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-toast></p-toast>
<app-loader></app-loader>
<aside *ngIf="sessionReplay.supportStatus$ | async as support" class="remote-support" data-openreplay-hidden
       aria-label="Soporte remoto">
    <span role="status">{{support === 'paused' ? 'Soporte remoto detenido' :
        support === 'controlling' ? 'Soporte tiene el control de esta pestaña' : 'Soporte está viendo esta pestaña'}}</span>
    <button *ngIf="support !== 'paused'" pButton type="button" label="Detener soporte" icon="pi pi-stop-circle"
            (click)="sessionReplay.stopSupport()"></button>
    <button *ngIf="support === 'paused'" pButton type="button" label="Habilitar soporte" icon="pi pi-headphones"
            (click)="sessionReplay.resumeSupport()"></button>
</aside>
<div *ngIf="workerScheduleBlocked" class="worker-schedule-overlay" role="alertdialog" aria-modal="true">
    <div class="worker-schedule-card">
        <i class="pi pi-clock worker-schedule-icon"></i>
        <h2>Estás fuera de horario</h2>
        <p>{{workerScheduleMessage}}</p>
        <button pButton type="button" label="Cerrar sesión" icon="pi pi-sign-out"
                (click)="logoutForSchedule()"></button>
    </div>
</div>
